transformations = {
  "meta.publication-type": {
    "operator": "Operator Manual",
    "maintenance": "Maintenance Guide",
  },
};
